import * as $ from "jquery";
import RegisterUserFormFields from "../Fields/RegisterUserFormFields";
import {initReCaptcha} from "../../Functions/InitReCaptcha";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";
import {onLoad, onClick, onChange, onKeyUp} from "Core/Events";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";

export const RegisterFormValidation = (() => {
    const Selector = {
        FORM: '#register-user-form',
        FORM_INPUTS: '#register-user-form .form-control',
        SUBMIT_BUTTON: '#register-user-submit',
        RECAPTCHA: '#register-user-form #g-recaptcha',
        RECAPTCHA_ERROR_MSG: '#register-user-form .g-recaptcha-error',
    };

    onLoad(initReCaptcha);
    onChange(Selector.FORM_INPUTS, validateFormFields)
    onKeyUp(Selector.FORM_INPUTS, validateFormFields)
    onClick(Selector.SUBMIT_BUTTON, submitRegisterForm);

    function submitRegisterForm() {
        if (validateAllForm()) {
            $(Selector.FORM).submit()
        }
    }

    function validateFormFields() {
        validateFormFieldsJquery();
    }

    function validateAllForm() {
        validateFormFieldsJquery();

        let formIsValid = $(Selector.FORM).valid();
        let recaptchaIsChecked = ReCaptchaValidation.validate(Selector.RECAPTCHA, Selector.RECAPTCHA_ERROR_MSG);

        return formIsValid && recaptchaIsChecked;
    }

    function validateFormFieldsJquery() {
        $(Selector.FORM).validate({
            ignore: '',
            rules: RegisterUserFormFields.getFields(Selector),
            errorPlacement: function (error, element) {
                $(element).parent().append(error)
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });
    }

    return true;
})();
import * as $ from "jquery";
import RegisterUserFormFields from "../Fields/RegisterUserFormFields";
import {initReCaptcha} from "../../Functions/InitReCaptcha";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";
import {onLoad, onClick, onChange, onKeyUp} from "Core/Events";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";

export const RegisterFormValidation = (() => {
    const Selector = {
        FORM: '#register-user-form',
        FORM_INPUTS: '#register-user-form .form-control',
        SUBMIT_BUTTON: '#register-user-submit',
        RECAPTCHA: '#register-user-form #g-recaptcha',
        RECAPTCHA_ERROR_MSG: '#register-user-form .g-recaptcha-error',
    };

    onLoad(initReCaptcha);
    onChange(Selector.FORM_INPUTS, validateFormFields)
    onKeyUp(Selector.FORM_INPUTS, validateFormFields)
    onClick(Selector.SUBMIT_BUTTON, submitRegisterForm);

    function submitRegisterForm() {
        if (validateAllForm()) {
            $(Selector.FORM).submit()
        }
    }

    function validateFormFields() {
        validateFormFieldsJquery();
    }

    function validateAllForm() {
        validateFormFieldsJquery();

        let formIsValid = $(Selector.FORM).valid();
        let recaptchaIsChecked = ReCaptchaValidation.validate(Selector.RECAPTCHA, Selector.RECAPTCHA_ERROR_MSG);

        return formIsValid && recaptchaIsChecked;
    }

    function validateFormFieldsJquery() {
        $(Selector.FORM).validate({
            ignore: '',
            rules: RegisterUserFormFields.getFields(Selector),
            errorPlacement: function (error, element) {
                $(element).parent().append(error)
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });
    }

    return true;
})();
